// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Jm","summaryPar":"Km","ratingCategories":"Lm","reviewerInfo":"Mm","reviewTypes":"Nm","expanded":"Om"};